import { IROPS_STATUS } from "@app/enums/irops.enum";
import { Reservation } from "../reservation.model";

export class RequestEligibilityIrops {
    reservationCode: string
    otherAirlineReservationCode: string //optional
    tripType: string
    passengerNumbers: string
    typeReservation: string
    currency: Currency //optional
    ticketTimeLimit: number
    transactionId: string
    lastName: string //optional
    isEmployee: boolean
    isStandBy: boolean
    isDirectSale: boolean //optional
    clid: string  //optional
    salesChannel: string  //optional
    bookedLegCollection: BookedLegCollection[]
    oldBookedLegCollection: any[]
    passengers: Passenger[]
    isNewBF: boolean

    constructor(reservation: Reservation) {
        this.reservationCode = reservation.pnr;
        this.otherAirlineReservationCode = ''; //optional
        this.tripType = reservation.tripType;
        this.passengerNumbers = reservation.passengers.length?.toString();
        this.typeReservation = reservation.typeReservation;
        this.currency = reservation.currency;
        this.ticketTimeLimit = reservation.ticketTimeLimit;
        this.transactionId = reservation.flightSummary.cartId;
        this.isEmployee = reservation.isEmployee;
        this.lastName = reservation.passengers[0]?.lastName || ''; //optional
        this.isStandBy = reservation.isStandBy;
        this.isDirectSale = false; //optional
        this.clid = ''; //optional
        this.salesChannel = ''; //optional
        this.bookedLegCollection = [new BookedLegCollection(reservation.flightSummary)];
        this.oldBookedLegCollection = [];
        this.passengers = reservation.passengers.map(passenger => new Passenger(passenger));
        this.isNewBF = reservation.isNewBF;
    }
}

export class BookedLegCollection {
    legCode: string
    legEntity: string
    legRegion: string
    fareFamily: string
    totalFlightDuration: number
    windowLegStatus: string
    segments: Segment[]

    constructor(leg: any) {
        this.legCode = leg.legCode;
        this.legEntity = leg.legEntity;
        this.legRegion = leg.legRegion;
        this.fareFamily = leg.fareFamily;
        this.totalFlightDuration = leg.totalFlightDuration;
        this.windowLegStatus = leg.windowLegStatus;
        this.segments = leg.segments.map((segment: any) => {
            return new Segment(segment);
        });
    }
}

export class Segment {
    id: string
    fareFamily: string
    segmentCode: string
    segmentEntity: string
    segmentRegion: string
    departureAirport: string
    departureTerminal: string
    departureDateTime: string
    arrivalAirport: string
    arrivalTerminal: string
    arrivalDateTime: string
    arrivalAirportRegion: string
    marketingCarrier: string
    marketingFlightCode: string
    operatingCarrier: string
    operatingFlightCode: string
    segmentStatusCode: string
    cabinClass: string
    bookingClass: string
    farebasis: string
    aircraftType: string
    flightDuration: number
    layoverDuration: number
    sequence: number
    onStandbyList: boolean
    onUpgradeList: boolean

    constructor(segment?: any) {
        if (segment) {
            const validIrops = segment?.flightsNewInfo && (segment?.flightsNewInfo?.status == IROPS_STATUS.DELAYED || segment?.flightsNewInfo?.status == IROPS_STATUS.EARLY); 
            this.id = segment.id;
            this.fareFamily = segment.fareFamily;
            this.segmentCode = segment.segmentCode;
            this.segmentEntity = segment.segmentEntity;
            this.segmentRegion = segment.segmentRegion;
            this.departureAirport = segment.departureAirport;
            this.departureTerminal = segment.departureTerminal;
            this.departureDateTime = validIrops ? segment?.flightsNewInfo?.departureDateTime : segment?.departureDateTime;
            this.arrivalAirport = segment.arrivalAirport;
            this.arrivalTerminal = segment.arrivalTerminal;
            this.arrivalDateTime = validIrops ? segment?.flightsNewInfo?.arrivalDateTime : segment.arrivalDateTime;
            this.arrivalAirportRegion = segment.arrivalAirportRegion;
            this.marketingCarrier = segment.marketingCarrier;
            this.marketingFlightCode = segment.marketingFlightCode;
            this.operatingCarrier = segment.operatingCarrier;
            this.operatingFlightCode = segment.operatingFlightCode;
            this.segmentStatusCode = segment.segmentStatusCode;
            this.cabinClass = segment.cabinClass;
            this.bookingClass = segment.bookingClass;
            this.farebasis = segment.farebasis;
            this.aircraftType = segment.aircraftType;
            this.flightDuration = segment.flightDuration;
            this.layoverDuration = segment.layoverDuration;
            this.sequence = segment.sequence;
            this.onStandbyList = segment.onStandbyList;
            this.onUpgradeList = segment.onUpgradeList;
        }
    }
}

export class Passenger {
    id: string
    passengerNameNumber: string
    passengerInfant: string
    priorityCode: string
    upgradeCode: string
    isWheelChair: boolean
    isMultipleTickets: boolean
    passengerDetails: PassengerDetails
    passengerInfo: PassengerInfo
    ticketInfo: TicketInfo
    ancillaries: Ancillary[]
    seats: any[]
    ssrs: any[]

    constructor(passenger: any) {
        this.id = passenger.id;
        this.passengerNameNumber = passenger.passengerNameNumber;
        this.passengerInfant = passenger.passengerInfant;
        this.priorityCode = passenger.priorityCode;
        this.upgradeCode = passenger.upgradeCode;
        this.isWheelChair = passenger.isWheelChair;
        this.isMultipleTickets = passenger.isMultipleTickets;
        this.passengerDetails = new PassengerDetails(passenger);
        this.passengerInfo = passenger.passengerInfo;
        this.ticketInfo = passenger.ticketInfo;
        this.ancillaries = passenger.ancillaries;
        this.seats = passenger.seats;
        this.ssrs = passenger.ssrs;
    }
}

export class PassengerDetails {
    firstName: string
    lastName: string

    constructor(passenger?: any) {
        if (passenger) {
            this.firstName = passenger.firstName;
            this.lastName = passenger.lastName;
        }
    }
}

export interface PassengerInfo {
    dateOfBirth: string
    gender: string
    type: string
    countryResidence: string
    redressNumber: any
    travelerNumber: any
    ffProgram: string
    ffNumber: string
    ffTierLevel: string
    emails: any[]
    phones: any[]
    passport: any
    visa: any
    permanentResidentCard: any
    emergencyContact: any
    destinationAddress: any
}

export interface TicketInfo {
    eticket: string
    coupons: Coupon[]
}

export interface Coupon {
    couponNumber: number
    couponStatus: string
    segmentCode: string
}

export interface Ancillary {
    status: string
    emd: string
    code: string
    groupCode: string
    nameDescription: string
    passengerId: string
    segmentCode: string
    currency: Currency2
}

export interface Currency {
    currencyCode: string
    base: number
    totalTaxes: number
    taxes: any
    total: number
    points: number
}

export interface Currency2 {
    currencyCode: string
    base: number
    totalTaxes: number
    taxes: any
    total: number
    points: number
}
